"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationRecordSign = DurationRecordSign;
var constants_1 = require("../constants");
function DurationRecordSign(record) {
    for (var _i = 0, TABLE_1_1 = constants_1.TABLE_1; _i < TABLE_1_1.length; _i++) {
        var key = TABLE_1_1[_i];
        if (record[key] < 0) {
            return -1;
        }
        if (record[key] > 0) {
            return 1;
        }
    }
    return 0;
}
